export default [
  {
    // path: '/actionCamera/:pageType',
    path: '/rescue',
    component: () => import('@/views/rescue/Index.vue'),
    name: 'rescue',
    meta: {
      title: '摔车救援服务',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/rescue-entrance',
    component: () => import('@/views/rescue/Entrance.vue'),
    name: 'rescue-entrance',
    meta: {
      title: '',
      backgroundClass: 'bg-gray',
    },
  },
];
